import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Button } from './ui/button';

const Hero = ({ onContactClick }) => {
  return (
    <section className="hero-section relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-brand-brown/40 to-black"></div>
      <div className="absolute top-20 right-10 w-96 h-96 bg-brand-olive/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-10 w-[500px] h-[500px] bg-brand-yellow/5 rounded-full blur-3xl"></div>
      
      {/* Animated grid overlay */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(rgba(165, 166, 117, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(165, 166, 117, 0.1) 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left content */}
            <div className="space-y-8">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-olive/20 rounded-full border border-brand-olive/40">
                <Sparkles className="w-4 h-4 text-brand-yellow" />
                <span className="text-sm font-medium text-brand-cream">UK-Based Digital Marketing Agency</span>
              </div>
              
              <h1 className="text-5xl lg:text-7xl font-bold leading-tight text-white drop-shadow-[0_0_30px_rgba(255,255,255,0.5)] shadow-[0_0_40px_rgba(255,255,255,0.3)]">
                Empowering Small Businesses to{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-maroon via-brand-olive to-brand-maroon drop-shadow-[0_0_20px_rgba(139,35,50,0.8)]">Shine Online</span>
              </h1>
              
              <p className="text-xl lg:text-2xl text-white leading-relaxed font-light tracking-wide drop-shadow-[0_2px_10px_rgba(0,0,0,0.8)]">
                Professional digital marketing and social media management for freelancers, 
                small businesses, and independent creators. Agency-quality results at accessible prices.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <Button 
                  onClick={onContactClick}
                  size="lg"
                  className="bg-brand-olive hover:bg-brand-olive/90 text-white font-semibold px-8 py-6 text-lg transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl"
                >
                  Book Free Consultation
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Button>
                <Button 
                  variant="outline"
                  size="lg"
                  className="border-2 border-brand-olive text-brand-olive hover:bg-brand-olive hover:text-white font-semibold px-8 py-6 text-lg transition-all duration-300"
                  onClick={() => document.getElementById('packages')?.scrollIntoView({ behavior: 'smooth' })}
                >
                  View Our Packages
                </Button>
              </div>
              
              <div className="flex items-center gap-8 pt-6">
                <div className="text-center">
                  <div className="text-3xl font-bold text-brand-maroon drop-shadow-[0_2px_8px_rgba(139,35,50,0.8)]">50+</div>
                  <div className="text-sm text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">Happy Clients</div>
                </div>
                <div className="w-px h-12 bg-brand-olive/30"></div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-brand-maroon drop-shadow-[0_2px_8px_rgba(139,35,50,0.8)]">300%</div>
                  <div className="text-sm text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">Avg. Growth</div>
                </div>
                <div className="w-px h-12 bg-brand-olive/30"></div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-brand-maroon drop-shadow-[0_2px_8px_rgba(139,35,50,0.8)]">24hr</div>
                  <div className="text-sm text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">Response Time</div>
                </div>
              </div>
            </div>
            
            {/* Right content - Logo */}
            <div className="flex justify-center lg:justify-end">
              <div className="relative">
                <div className="absolute inset-0 bg-brand-yellow/20 rounded-full blur-2xl scale-110"></div>
                <img 
                  src="https://customer-assets.emergentagent.com/job_50a99d4b-16e5-4a25-a3c2-534efc6745c6/artifacts/9ur1riyu_d51c164a-21d7-4291-b45e-5c3d3e3a1260-1_all_5079.jpg" 
                  alt="JRT Chideme Media Logo" 
                  className="relative w-full max-w-md rounded-2xl shadow-2xl hover:scale-105 transition-transform duration-500 border-2 border-brand-olive/30"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
